import { merge } from 'lodash';

import { PillowType } from '../../../../../components/shared/PillowImage/pillowTypes';
import { populateFields } from '../../../../../forms/populateFields';
import { editIncomeForm } from '../../../../../utils/helpers/income/editIncomeForm';
import { withContext } from '../../../../../utils/workflow/withContext';
import BaseModel from '../common/BaseModel';

const model = merge({}, BaseModel, {
  template: {
    header: {
      showClose: false,
      showBack: true,
    },
    footer: {
      isActive: false,
    },
    img: {
      type: PillowType.PERSONAL_DATA,
    },
  },
  form: editIncomeForm,
  info: {
    title: 'Review income details',
    subtitle: 'Help',
    content: [
      {
        copy: [
          'Does everything look correct? Use this time to correct any mistakes or confirm these details, as accurate information will allow for the smoothest application process possible.',
        ],
      },
    ],
  },
  headerBlock: {
    title: 'Edit your income details.',
    subtitle: ['Applicant', '80% complete'],
    progressBar: {
      progress: 80,
      withContainer: true,
    },
  },
});

const populateData =
  (fields: any) =>
  (send: any, { context }: any) => {
    return populateFields(fields, context.updatedUser.incomes);
  };

const modelFn = (...args: [any, any]) =>
  withContext({ model, populateFields: populateData })(...args);

export default modelFn;
